<div class="book-info">
  <img [src]="bookInfo?.cover" alt="book cover" />
  <div class="book-info-text">
    <p class="book-info-text-title" *ngIf="bookInfo?.title">
      {{ bookInfo?.title }}
    </p>
    <p class="book-info-text-author" *ngIf="bookInfo?.author">
      {{ bookInfo?.author }}
    </p>
  </div>
  <ng-content></ng-content>
</div>
